/** @jsxImportSource @emotion/react */
import React from 'react'

import { Table, TableCol, TableRow } from '../../../../../../components/pdf/Table'
import Image from '../../../../../../components/presentation/Image'
import Text from '../../../../../../components/pdf/Text'
import Grid, { Col } from '../../../../../../components/pdf/Grid'

const OSHeader = ({ startPage = '1', endPage = '3' }) => {
  return (
    <Table width="100%">
      <TableRow>
        <TableCol rowSpan={2} colSpan={2}>
          <Grid justify="center">
            <Image src="/pdfs/bosi/logo.jpg" width="151px" />
          </Grid>
        </TableCol>
        <TableCol rowSpan={2} colSpan={5}>
          <Text bold size={14} align="center" style={{ fontWeight: 700 }}>
            ORDEM DE SERVIÇO DE SEGURANÇA E SAÚDE OCUPACIONAL
          </Text>
        </TableCol>
        <TableCol>
          <Text align="center">REV. 01 – 06/09/2023</Text>
        </TableCol>
      </TableRow>
      <TableRow>
        <TableCol>
          <Text align="center">{`Página ${startPage} de ${endPage}`}</Text>
        </TableCol>
      </TableRow>
    </Table>
  )
}

export default OSHeader
